import {takeUntil} from 'rxjs/operators';
import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';

import {ActivatedRoute, Router, RouterModule} from '@angular/router';

import {AppStateService} from '../services/app-state.service';
import {AuthService} from '../services/auth.service';

import {CommonModule, DOCUMENT} from '@angular/common';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {AppUser} from '../interfaces/app-user';
import {MatButton} from '@angular/material/button';
import {MatToolbar} from '@angular/material/toolbar';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatIcon} from '@angular/material/icon';
import {MatCard, MatCardContent} from '@angular/material/card';
import {FooterComponent} from '../shared/components/footer/footer.component';



@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: true,
    imports: [CommonModule, RouterModule, MatButton, MatToolbar, MatMenuItem, MatMenuTrigger, MatProgressSpinner, MatIcon, MatMenu, MatCardContent, MatCard, FooterComponent]
})
export class HomeComponent implements OnInit, OnDestroy {

    /**
     * Set our default values
     */
    public isLoginError = false;

    public authCheckEmitter$ = new BehaviorSubject<boolean>(false);
    public canSeeBudgets$;
    public userStream$: Observable<AppUser>;

    private unsubscribe$ = new Subject();

    /**
     * TypeScript public modifiers
     */
    constructor(
        public appState: AppStateService,
        private authService: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        @Inject(DOCUMENT) private _document: Document,
        private _changeDetectionRef: ChangeDetectorRef
    ) {
    }

    get authDomain() {
        if (this.authService) {
            return this.authService.appDomain;
        } else {
            return '';
        }
    }

    public ngOnInit() {
        // Start loading auth data
        this.route.queryParams
            .subscribe(params => {
                this.setLoginError(params['loginError']);
            });


        this.userStream$ = this.authService.userStream$;

        this.authService.userStream$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((user) => {
                this.authCheckEmitter$.next(true);
                this._changeDetectionRef.detectChanges();
            }, (err) => {
                console.log('Error occured on user stream. ', err);
                this.authCheckEmitter$.next(false);
            });

        this.canSeeBudgets$ = this.authService.userHasPermission('app.budget');

        if (window.location.hostname.indexOf('evtest.wonder-sys.com') !== -1) {
            console.log('TIS app. Loading TIS home assets.', window.location.hostname);
            this._document.getElementById('logo-home').setAttribute('src', '/assets/img/logoTISv3.ico');
            this._document.getElementById('logo-home').setAttribute('class', 'logo-tis');
            this._document.getElementById('main').style.backgroundImage = 'url(\'/assets/img/sfondo_tis.jpg\')';
            this._document.getElementById('main').style.backgroundSize = '100%';
            this._document.getElementById('main').style.backgroundPosition = 'center';
        }

        if (window.location.hostname.indexOf('extraglass') !== -1) {
            console.log('Extraglass app. Loading Extraglass home assets.', window.location.hostname);
            this._document.getElementById('logo-home').setAttribute('src', '/assets/img/extraglass.png');
            this._document.getElementById('logo-home').setAttribute('class', 'logo-extraglass');
            this._document.getElementById('main').style.backgroundImage = 'url(\'/assets/img/sfondo-eg.jpg\')';
            this._document.getElementById('main').style.backgroundSize = '100%';
            this._document.getElementById('main').style.backgroundPosition = 'center';
        }
    }

    public ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    public loginWithGoogle() {
        this.authService.signInWithGoogle();
    }

    public logoutWithFireBase() {
        console.log('logoutUser');
        this.authService.logout().then(() => {
            this.router.navigate(['/home']);
        });
    }

    public setLoginError(isError) {
        this.isLoginError = isError === 'true' || isError === true ? isError : false;
        console.log('login error: ', this.isLoginError);
    }

}
